import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiChevronRight } from '@mdi/js';

function Submenu({ subm, authSubm, pathname }) {
  let url = subm.alias;
  const regex = new RegExp(url);
  const isActive = regex.test(pathname);
  const accessSubm = authSubm[subm.id + '_view'];

  return (
    <>
      {accessSubm && (
        <li>
          <Link
            to={subm.subUrl}
            className={`is-size-6 custom-text-overflow disable-select${
              isActive === true ? ' is-active' : ''
            }`}
          >
            <span className='flex align-center'>
              <Icon path={mdiChevronRight} size={0.65} />
              <span className='ml-1'>{subm.submenuTitle}</span>
            </span>
          </Link>
        </li>
      )}
    </>
  );
}

export default Submenu;